import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, Box, CircularProgress } from '@material-ui/core'
import clsx from 'clsx'
import Icon from '../../../../atoms/Icon'
import SydCheckbox from '../../../../commonDesign/SydCheckbox'

const useStyles = makeStyles((theme) => ({
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    overflowY: 'auto'
  },
  listItem: {
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    '&:hover': {
      backgroundColor: 'var(--color-neutral-100)'
    }
  },
  selected: {
    backgroundColor: 'var(--color-primary-500)',
    color: 'var(--color-primary-050)',
    '&:hover': {
      backgroundColor: 'var(--color-primary-600)'
    },
    '& .MuiCheckbox-root': {
      color: '#ffffff !important'
    },
    '& .MuiCheckbox-root.Mui-checked': {
      color: '#ffffff !important',
      backgroundColor: 'rgba(255, 255, 255, 0.25) !important'
    },
    '& .MuiCheckbox-root.Mui-disabled': {
      color: 'rgba(255, 255, 255, 0.8) !important',
      opacity: '1 !important'
    },
    '& .MuiCheckbox-root.Mui-checked.Mui-disabled': {
      color: '#ffffff !important',
      backgroundColor: 'rgba(255, 255, 255, 0.2) !important'
    },
    '& .MuiSvgIcon-root': {
      color: 'inherit !important'
    }
  },
  newItem: {
    fontStyle: 'italic',
    color: 'var(--color-primary-600)',
    fontWeight: 500
  },
  skillName: {
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2)
  }
}))

function SkillList ({ skills, selectedSkillId, isNewSelected, onSelectNew, onSelectSkill, isLoading }) {
  const classes = useStyles()

  if (isLoading) {
    return (
      <Box className={classes.loading}>
        <CircularProgress size={24} />
      </Box>
    )
  }

  return (
    <div className={classes.list}>
      <div
        className={clsx(classes.listItem, classes.newItem, {
          [classes.selected]: isNewSelected
        })}
        onClick={onSelectNew}
      >
        <Icon name='add' style={{ fontSize: '16px' }} />
        <span className={classes.skillName}>New</span>
      </div>
      {skills.map((skill) => {
        // Handle enabled state - check both skillContent.enabled and direct enabled property
        // Use Boolean() to handle truthy values
        const content = skill.skillContent || {}
        const isEnabled = Boolean(content.enabled) || Boolean(skill.enabled)
        const isSelected = selectedSkillId === skill.skillId

        return (
          <div
            key={skill.skillId}
            className={clsx(classes.listItem, {
              [classes.selected]: isSelected
            })}
            onClick={() => onSelectSkill(skill.skillId)}
          >
            <SydCheckbox
              value={isEnabled}
              disabled
              size='small'
            />
            <span className={classes.skillName}>{skill.skillName}</span>
          </div>
        )
      })}
    </div>
  )
}

SkillList.propTypes = {
  skills: PropTypes.arrayOf(PropTypes.object),
  selectedSkillId: PropTypes.string,
  isNewSelected: PropTypes.bool,
  onSelectNew: PropTypes.func.isRequired,
  onSelectSkill: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
}

SkillList.defaultProps = {
  skills: [],
  selectedSkillId: null,
  isNewSelected: false,
  isLoading: false
}

export default SkillList
